import React from 'react';
import Checked from "../../images/checked.svg";
import { useNavigate } from "react-router-dom";
import { portalPageTitle, portalSecondaryPillButton } from "../../theme/portalLayout";

function PaymentMethodAdded() {
    const navigate = useNavigate();

    const handleGoBackToBilling = () => {
        navigate('/billing');
    };

    return (
        <div className="my-xl text-center text-portal-teal">
            <div className="w-full flex justify-center mb-5">
                <img className="w-12 h-12 mt-3" src={Checked} alt="" aria-hidden="true"/>
            </div>
            <h1 className={`${portalPageTitle} mb-4`}>Well done</h1>
            <p className="mb-5 text-p1 font-medium max-w-lg mx-auto">You have successfully registered your billing details.</p>
            <div>
                <button
                    type="button"
                    className={portalSecondaryPillButton}
                    onClick={handleGoBackToBilling}
                >
                    Go back to billing
                </button>
            </div>
        </div>
    );
}

export default PaymentMethodAdded;